import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import {ApiService} from '../../../../api/api.service';
import { LoaderService } from '../../../../api/loader.service';
import { CatalogCacheService } from 'src/app/services/catalog-cache.service';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-assistance-ticket-exception',
    templateUrl: './assistance-ticket-exception.component.html',
    styleUrls: ['./assistance-ticket-exception.component.css'],
    standalone: false
})
export class AssistanceTicketExceptionComponent implements OnInit, OnDestroy {

  @Input() ticket: EventEmitter<AssistanceTicket>;
  @Output() create = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  isDisabled = false;

  supervisors = [];
  exceptionsType = [];
  assistanceTicket:AssistanceTicket = new AssistanceTicket();
  private destroy$ = new Subject<void>();

  constructor(
    private api: ApiService,
    private LoaderService: LoaderService,
    private catalogCache: CatalogCacheService
  ) { }

  ngOnInit() {  

    this.reset();
  
    this.ticket.subscribe(data => {
      this.assistanceTicket = Object.assign({}, data.ticket);
      if(!this.assistanceTicket.id) {
        this.assistanceTicket.ticket_type = 14;  //exception
        delete this.assistanceTicket.comment;
        delete this.assistanceTicket.supervisor_id;
        delete this.assistanceTicket.exception_type;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initialize(){
    this.LoaderService.display(true)
    this.loadSupervisors();
    this.loadExceptionType();
  }
  reset() {
    this.isDisabled = false;   
    this.assistanceTicket = new AssistanceTicket();
  }

  onCancel() {
    this.reset();    
    this.cancelEvent.emit();
  }

  onSubmit() {
    this.isDisabled = true;    
    this.create.emit(this.assistanceTicket);    
    this.reset();    
  }

  loadSupervisors(){    
    this.api.assistancetickets.getExceptionSupervisor().promise()
      .then(supervisors => {
        this.supervisors = supervisors;  
       this.LoaderService.display(false)      
      });
  }

  loadExceptionType(){
    this.LoaderService.display(true);
    this.catalogCache.getExceptionTypes()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.LoaderService.display(false))
      )
      .subscribe({
        next: (types) => {
          this.exceptionsType = types;
        },
        error: (error) => {
          console.error('Error loading exception types:', error);
          this.exceptionsType = [];
        }
      });
  }

  parseToBoolean(n:any) {
    return Boolean(n)
  }
}
